import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  const sections = [
    {
      id: 'story',
      title: 'ストーリー',
      subtitle: '現場から生まれた、続けられる仕組み',
      description: '「良いことを、続けられる形に」——ボランティアが無理なく継続でき、居場所も助かる仕組みを目指して開発しました。',
      image: 'https://public.readdy.ai/ai/img_res/94de8b486819e287f0922d46903b30f1.jpg',
      link: '/story',
      icon: 'ri-heart-line',
      color: 'from-pink-500 to-rose-500'
    },
    {
      id: 'how-it-works',
      title: 'しくみ',
      subtitle: '3つのステップで簡単スタート',
      description: '課題アップロード、マッチング、授業開始。最短1分で学習支援が始まります。AIサポートと柔軟な参加スタイルで続けやすい。',
      image: 'https://readdy.ai/api/search-image?query=clean%20modern%20illustration%20showing%20three%20simple%20steps%20of%20online%20learning%20process%2C%20Japanese%20student%20uploading%20homework%2C%20matching%20with%20tutor%2C%20and%20video%20call%20session%2C%20minimalist%20design%20with%20soft%20blue%20and%20teal%20colors%2C%20educational%20technology%20concept%2C%20simple%20background%20with%20floating%20icons%20and%20connecting%20lines&width=600&height=400&seq=home-howitworks&orientation=landscape',
      link: '/how-it-works',
      icon: 'ri-settings-3-line',
      color: 'from-blue-500 to-teal-500'
    },
    {
      id: 'safety',
      title: '安全・FAQ',
      subtitle: '安全をいちばんに。迷ったらすぐ相談',
      description: '登録時の同意確認、報告フォーム、メールサポート。運営チームが速やかに問題解決をサポートします。',
      image: 'https://readdy.ai/api/search-image?query=reassuring%20illustration%20of%20safety%20and%20security%20in%20online%20education%2C%20protective%20shield%20icon%20with%20checkmarks%2C%20Japanese%20people%20using%20secure%20digital%20platform%2C%20trust%20and%20safety%20symbols%2C%20calming%20green%20and%20blue%20colors%2C%20professional%20yet%20friendly%20atmosphere%2C%20simple%20clean%20background%20emphasizing%20protection%20and%20support&width=600&height=400&seq=home-safety&orientation=landscape',
      link: '/safety',
      icon: 'ri-shield-check-line',
      color: 'from-green-500 to-emerald-500'
    },
    {
      id: 'note',
      title: 'note',
      subtitle: '活動の記録と想い',
      description: 'ボラタスの活動記録や開発の背景、利用者の声などをnoteで発信しています。',
      image: 'https://readdy.ai/api/search-image?query=creative%20illustration%20of%20blog%20and%20article%20writing%2C%20notebook%20with%20pen%20and%20digital%20content%2C%20Japanese%20style%20minimalist%20design%2C%20warm%20orange%20and%20yellow%20colors%2C%20inspiring%20and%20thoughtful%20atmosphere%2C%20simple%20background%20with%20floating%20text%20and%20document%20icons%2C%20storytelling%20concept&width=600&height=400&seq=home-note&orientation=landscape',
      link: 'https://note.com/villehama',
      icon: 'ri-article-line',
      color: 'from-orange-500 to-amber-500',
      external: true
    }
  ];

  const userSections = [
    {
      id: 'for-places',
      title: '居場所の皆さまへ',
      subtitle: '運営の手間を減らして、子どもと向き合う時間を',
      description: '謝金支払いの簡素化、安全面の相談、柔軟な参加スタイル。運営負担を軽減し、本来の支援活動に集中できます。',
      image: 'https://readdy.ai/api/search-image?query=warm%20illustration%20of%20Japanese%20community%20learning%20center%20staff%20working%20with%20children%2C%20caring%20teachers%20and%20students%20in%20bright%20welcoming%20space%2C%20educational%20materials%20and%20books%2C%20soft%20pastel%20colors%2C%20natural%20lighting%2C%20supportive%20and%20nurturing%20atmosphere%2C%20simple%20clean%20background%20emphasizing%20care%20and%20education&width=600&height=400&seq=home-places&orientation=landscape',
      link: '/for-places',
      icon: 'ri-home-heart-line',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      id: 'for-volunteers',
      title: 'ボランティアの皆さまへ',
      subtitle: '「続けたい」を支える仕組み',
      description: '無理なく続けられるスケジュール、明確な謝金システム、いつでも相談できるサポート体制。あなたの「良いことをしたい」気持ちを応援します。',
      image: 'https://readdy.ai/api/search-image?query=inspiring%20illustration%20of%20young%20Japanese%20volunteers%20helping%20children%20with%20online%20tutoring%2C%20smiling%20faces%2C%20laptop%20and%20educational%20materials%2C%20encouraging%20and%20positive%20atmosphere%2C%20soft%20blue%20and%20purple%20colors%2C%20collaborative%20learning%20environment%2C%20simple%20clean%20background%20emphasizing%20support%20and%20growth&width=600&height=400&seq=home-volunteers&orientation=landscape',
      link: '/for-volunteers',
      icon: 'ri-user-heart-line',
      color: 'from-purple-500 to-indigo-500'
    }
  ];

  const resourceSections = [
    {
      id: 'manual',
      title: '操作マニュアル',
      description: '管理者、居場所、ボランティア、それぞれの役割に応じた詳しい操作方法をご案内します。',
      image: 'https://readdy.ai/api/search-image?query=clean%20illustration%20of%20user%20manual%20and%20guide%20book%2C%20step%20by%20step%20instructions%20with%20icons%2C%20Japanese%20interface%20design%2C%20organized%20and%20clear%20layout%2C%20professional%20blue%20and%20gray%20colors%2C%20educational%20technology%20documentation%2C%20simple%20background%20with%20numbered%20steps%20and%20arrows&width=400&height=300&seq=home-manual&orientation=landscape',
      link: '/manual',
      icon: 'ri-book-2-line',
      color: 'from-blue-600 to-indigo-600'
    },
    {
      id: 'materials',
      title: 'おすすめ教材',
      description: 'ボラタスでの学習に活用できる、無料で使える優良教材サイトをご紹介します。',
      image: 'https://readdy.ai/api/search-image?query=colorful%20illustration%20of%20educational%20materials%20and%20learning%20resources%2C%20textbooks%20worksheets%20and%20study%20materials%2C%20Japanese%20school%20supplies%2C%20bright%20and%20cheerful%20colors%2C%20organized%20learning%20tools%2C%20simple%20clean%20background%20with%20educational%20icons%20and%20books%2C%20inspiring%20study%20atmosphere&width=400&height=300&seq=home-materials&orientation=landscape',
      link: 'https://kyo-colle.com/',
      icon: 'ri-book-open-line',
      color: 'from-orange-600 to-pink-600',
      external: true
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-20 pb-24 px-4 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img 
            src="https://readdy.ai/api/search-image?query=soft%20dreamy%20illustration%20of%20Japanese%20children%20and%20volunteers%20learning%20together%20in%20bright%20welcoming%20space%2C%20warm%20sunlight%20streaming%20through%20windows%2C%20books%20and%20educational%20materials%2C%20hopeful%20and%20encouraging%20atmosphere%2C%20pastel%20colors%20with%20teal%20and%20blue%20tones%2C%20simple%20clean%20background%20emphasizing%20connection%20and%20growth%2C%20gentle%20bokeh%20effect&width=1920&height=800&seq=home-hero-bg&orientation=landscape"
            alt="背景"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto">
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight drop-shadow-lg">
              良いことが、<br />
              ちゃんと続くために。
            </h1>
            
            <p className="text-xl md:text-3xl mb-6 leading-relaxed drop-shadow-md">
              居場所とボランティアをやさしくつなぐ<br />
              学習支援サービス『ボラタス』
            </p>

            <p className="text-base md:text-lg mb-12 leading-relaxed drop-shadow-md opacity-90">
              支援する人が無理なく続けられることが、<br className="md:hidden" />こどもたちの安心と学びにつながる。
            </p>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="https://boratasu.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-teal-600 text-white px-10 py-5 rounded-xl font-bold text-lg hover:bg-teal-700 transition-all shadow-2xl hover:shadow-3xl whitespace-nowrap cursor-pointer inline-block transform hover:scale-105"
              >
                <i className="ri-smartphone-line mr-2"></i>
                サービスを使ってみる
              </a>
              <a 
                href="/contact"
                className="bg-white/90 text-teal-600 px-10 py-5 rounded-xl font-bold text-lg hover:bg-white transition-all shadow-2xl hover:shadow-3xl whitespace-nowrap cursor-pointer inline-block transform hover:scale-105"
              >
                <i className="ri-mail-line mr-2"></i>
                お問い合わせ
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* PWA説明セクション */}
      <section className="py-12 px-4 bg-gradient-to-br from-blue-50 to-teal-50">
        <div className="max-w-4xl mx-auto text-center">
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="flex items-center justify-center mb-4">
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center">
                <i className="ri-smartphone-line text-2xl text-teal-600"></i>
              </div>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              ブラウザで使えるオンラインサービス
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed mb-3">
              ボラタスは、ブラウザで使えるオンライン学習支援マッチングサービス（PWA）です。<br />
              スマホはホーム画面に追加するとネイティブアプリのように使えます。
            </p>
            <p className="text-sm text-gray-600">
              App Store / Google Play からのダウンロードは不要です。
            </p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
              サービスについて
            </h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
              ボラタスの想い、仕組み、安全への取り組みをご紹介します
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {sections.map((section, index) => (
              <a
                key={section.id}
                href={section.link}
                target={section.external ? '_blank' : undefined}
                rel={section.external ? 'noopener noreferrer' : undefined}
                className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 cursor-pointer"
              >
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={section.image}
                    alt={section.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className={`absolute top-4 left-4 w-14 h-14 bg-gradient-to-br ${section.color} rounded-2xl flex items-center justify-center shadow-lg`}>
                    <i className={`${section.icon} text-2xl text-white`}></i>
                  </div>
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    {section.title}
                    {section.external && <i className="ri-external-link-line ml-2 text-lg"></i>}
                  </h3>
                  <p className="text-lg font-semibold text-teal-600 mb-3">{section.subtitle}</p>
                  <p className="text-gray-600 leading-relaxed">{section.description}</p>
                  <div className="mt-6 flex items-center text-teal-600 font-semibold group-hover:translate-x-2 transition-transform">
                    詳しく見る
                    <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </div>
              </a>
            ))}
          </div>

          {/* クラファン開始のお知らせ CTA */}
          <div className="mt-16 bg-gradient-to-r from-orange-500 to-pink-500 rounded-3xl p-8 md:p-12 shadow-2xl text-center text-white">
            <div className="max-w-4xl mx-auto">
              <div className="inline-block bg-white/20 backdrop-blur-sm px-6 py-2 rounded-full font-bold text-sm mb-6">
                <i className="ri-megaphone-line mr-2"></i>
                お知らせ
              </div>
              <h3 className="text-3xl md:text-4xl font-bold mb-6">
                クラファンを開始しました
              </h3>
              <p className="text-lg md:text-xl mb-4 leading-relaxed opacity-95">
                集まった支援で、学習支援を必要とする"居場所"へボラタスのオンライン学習支援を届けます。
              </p>
              <p className="text-lg md:text-xl mb-8 leading-relaxed opacity-95">
                支援したい方はクラファンへ。学習支援を受け取りたい居場所（団体）は募集ページへお進みください。
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href="https://for-good.net/project/1003002"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-white text-orange-600 px-10 py-5 rounded-xl font-bold text-lg hover:bg-gray-100 transition-all shadow-2xl hover:shadow-3xl whitespace-nowrap cursor-pointer transform hover:scale-105"
                >
                  <i className="ri-external-link-line mr-2"></i>
                  クラファンはこちら
                </a>
                <a
                  href="https://kyo-colle.com/ibasho-cf/index.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-white text-orange-600 px-10 py-5 rounded-xl font-bold text-lg hover:bg-gray-100 transition-all shadow-2xl hover:shadow-3xl whitespace-nowrap cursor-pointer transform hover:scale-105"
                >
                  <i className="ri-external-link-line mr-2"></i>
                  居場所募集はこちら
                </a>
              </div>
              <div className="mt-6">
                <a
                  href="https://boratasu.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white/90 hover:text-white underline cursor-pointer"
                >
                  ボランティアの登録は随時受付中です。ぜひご登録ください。
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Users Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-teal-50 to-blue-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
              利用者の方へ
            </h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
              支援する人が無理なく続けられることが、こどもたちの安心と学びにつながると考えています。
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {userSections.map((section) => (
              <a
                key={section.id}
                href={section.link}
                className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 border-2 border-gray-100 hover:border-teal-200 cursor-pointer"
              >
                <div className="relative h-72 overflow-hidden">
                  <img 
                    src={section.image}
                    alt={section.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className={`absolute top-4 left-4 w-16 h-16 bg-gradient-to-br ${section.color} rounded-2xl flex items-center justify-center shadow-lg`}>
                    <i className={`${section.icon} text-3xl text-white`}></i>
                  </div>
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    {section.title}
                  </h3>
                  <p className="text-lg font-semibold text-teal-600 mb-3">{section.subtitle}</p>
                  <p className="text-gray-600 leading-relaxed mb-6">{section.description}</p>
                  <div className="flex items-center text-teal-600 font-semibold group-hover:translate-x-2 transition-transform">
                    詳しく見る
                    <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Resources Section */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
              お役立ち情報
            </h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
              操作マニュアルとおすすめ教材
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {resourceSections.map((section) => (
              <a
                key={section.id}
                href={section.link}
                target={section.external ? '_blank' : undefined}
                rel={section.external ? 'noopener noreferrer' : undefined}
                className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 cursor-pointer"
              >
                <div className="relative h-64 overflow-hidden">
                  <img 
                    src={section.image}
                    alt={section.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className={`absolute top-4 left-4 w-14 h-14 bg-gradient-to-br ${section.color} rounded-2xl flex items-center justify-center shadow-lg`}>
                    <i className={`${section.icon} text-2xl text-white`}></i>
                  </div>
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-blue-600 transition-colors">
                    {section.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-6">{section.description}</p>
                  <div className="flex items-center text-blue-600 font-semibold group-hover:translate-x-2 transition-transform">
                    詳しく見る
                    <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Features Highlight */}
      <section className="py-20 px-4 bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
              ボラタスの特徴
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              支援者の手間や負担を減らし、こどもに向き合う時間を増やすために、このサービスをつくりました。
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-white rounded-3xl shadow-lg">
              <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-time-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">最短1分で授業開始</h3>
              <p className="text-gray-600 leading-relaxed">
                課題をアップロードしてマッチングするだけ。すぐに学習支援が始まります。
              </p>
            </div>

            <div className="text-center p-8 bg-white rounded-3xl shadow-lg">
              <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-robot-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">AIサポート</h3>
              <p className="text-gray-600 leading-relaxed">
                課題をAIが解析して指導アドバイスを作成。ボランティアが安心して参加できます。
              </p>
            </div>

            <div className="text-center p-8 bg-white rounded-3xl shadow-lg">
              <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">安心・安全</h3>
              <p className="text-gray-600 leading-relaxed">
                登録時の同意確認、報告フォーム、運営サポートで安全な環境を提供します。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-4 bg-gradient-to-r from-teal-600 to-blue-600">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            一緒に、良いことを続けませんか？
          </h2>
          <p className="text-lg md:text-xl mb-12 opacity-90">
            ボラタスで、子どもたちの学びと成長を支えましょう
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://boratasu.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white text-teal-600 px-10 py-5 rounded-xl font-bold text-lg hover:bg-gray-100 transition-all shadow-2xl hover:shadow-3xl whitespace-nowrap cursor-pointer inline-block transform hover:scale-105"
            >
              <i className="ri-smartphone-line mr-2"></i>
              サービスを使ってみる
            </a>
            <a 
              href="/contact"
              className="bg-transparent border-2 border-white text-white px-10 py-5 rounded-xl font-bold text-lg hover:bg-white hover:text-teal-600 transition-all shadow-2xl hover:shadow-3xl whitespace-nowrap cursor-pointer inline-block transform hover:scale-105"
            >
              <i className="ri-mail-line mr-2"></i>
              お問い合わせ
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
